import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var ChevronDownOutlineIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M21.67 7.016a1.09 1.09 0 010 1.563l-8.952 8.63a1.03 1.03 0 01-1.437 0L2.33 8.578a1.09 1.09 0 010-1.563l.232-.224a1.03 1.03 0 011.437 0l8 7.713L20 6.792a1.03 1.03 0 011.437 0l.233.224z", fill: "currentColor" })] })));
};

export { ChevronDownOutlineIcon };
//# sourceMappingURL=ChevronDownOutlineIcon.js.map
